function validatePoBox(
  input,
  poBoxErrorMessage,
) {
  const lowerCase = input.value.toLowerCase().replaceAll('.', '');
  const poBoxRegex = /(\W|^)(po\s*\S*\s*\d*$|(po box|post office|pobox))(\W|$)/;
  const isPoBox = poBoxRegex.test(lowerCase);
  if (isPoBox) {
    input.setCustomValidity('Invalid address type');
    poBoxErrorMessage.classList.remove('hidden');
  } else {
    input.setCustomValidity('');
    poBoxErrorMessage.classList.add('hidden');
  }
};

function validateMilitaryCity(
  input,
  militaryErrorMessage,
) {
  const militaryRegex = /\b(?:A[ .]?P[ .]?O|F[ .]?P[ .]?O|D[ .]?P[ .]?O)\b/i;
  const isMilitary = militaryRegex.test(input.value);
  
  if (isMilitary) {
    input.setCustomValidity('Invalid address type');
    militaryErrorMessage.classList.remove('hidden');
  } else {
    input.setCustomValidity('');
    militaryErrorMessage.classList.add('hidden');
  }
};